import { CustomFieldDefinition } from "gen/clients";
import { sanitizeFieldName } from "../formikUtils";

export class CustomFieldUtils {
  /**
   * Determines the visibility of a custom field based on its definition and the current form values.
   *
   * @param {CustomFieldDefinition} customFieldDefinition - The definition of the custom field, including visibility rules.
   * @param {Record<string, any>} formValues - The current values of the form fields, used for conditional visibility checks.
   * @return {boolean} True if the custom field is visible, otherwise false.
   */
  public static isCustomFieldVisible(customFieldDefinition: CustomFieldDefinition, formValues: Record<string, any>) {
    if (customFieldDefinition.visible) {
      return true;
    }
    if (customFieldDefinition.visibleIf && customFieldDefinition.visibleIf.length > 0) {
      const visibleIf = customFieldDefinition.visibleIf[0];
      return formValues[sanitizeFieldName(visibleIf.fieldName)] === visibleIf.value;
    }
    return false;
  }
}
